export enum JpkVatCodes {
    SW = 'SW',
    EE = 'EE',
    TP = 'TP',
    TT_WNT = 'TT_WNT',
    TT_D = 'TT_D',
    MR_T = 'MR_T',
    MR_UZ = 'MR_UZ',
    I_42 = 'I_42',
    I_63 = 'I_63',
    B_SPV = 'B_SPV',
    B_SPV_DOSTAWA = 'B_SPV_DOSTAWA',
    B_MPV_PROWIZJA = 'B_MPV_PROWIZJA',
    MPP = 'MPP',
    IMP = 'IMP',

    WSTO_EE = 'WSTO_EE',
    IED = 'IED'
}
